/**
 * Boxed Testimonials – Stories: Scroll Animations
 *
 * Uses IntersectionObserver to reveal [data-animate-item] elements
 * inside sections marked with [data-testimonials-stories].
 *
 * If JS fails or is disabled, content remains visible because
 * initial hidden styles only apply under the .bts-is-enhanced class.
 *
 * ARCHITECTURE NOTE:
 * This script only handles triggering the animation via CSS classes.
 * All transform/positioning logic is handled in CSS using CSS variables:
 *
 * - --bts-card-rest-x/y: Final resting position for cards (set by theme editor)
 * - --bts-image-rest-x/y: Final resting position for images (set by theme editor)
 * - --bts-*-rest-x/y-mobile: Mobile-specific resting positions
 * - --dir-x, --bts-ty: Animation-only offsets (initial state relative to rest)
 *
 * Animation flow:
 * 1. Initial state (before .bts-is-in-view): resting position + animation offset
 * 2. Final state (with .bts-is-in-view): resting position only
 *
 * The CSS transitions between these states using the duration/stagger
 * values configured in the section settings.
 */
(function () {
  "use strict";

  function init() {
    var sections = document.querySelectorAll("[data-testimonials-stories]");
    if (!sections.length) return;

    for (var i = 0; i < sections.length; i++) {
      setupSection(sections[i]);
    }
  }

  function setupSection(section) {
    var items = section.querySelectorAll("[data-animate-item]");
    if (!items.length) return;

    // Read config from data attributes
    var thresholdPercent =
      parseFloat(section.getAttribute("data-bts-threshold")) || 30;
    var threshold = thresholdPercent / 100;
    var rootMarginBottom =
      section.getAttribute("data-bts-root-margin") || "-25%";
    var animateOnce = section.getAttribute("data-bts-once") !== "false";

    // Assign stagger indices
    for (var i = 0; i < items.length; i++) {
      items[i].style.setProperty("--bts-index", i);
    }

    // Add enhancement class — this enables the initial hidden CSS state
    section.classList.add("bts-is-enhanced");

    // Check for reduced motion — if so, skip observer entirely
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      return;
    }

    // Build rootMargin: "0px 0px <bottom> 0px"
    var rootMargin = "0px 0px " + rootMarginBottom + " 0px";

    var observer = new IntersectionObserver(
      function (entries) {
        for (var j = 0; j < entries.length; j++) {
          var entry = entries[j];
          if (entry.isIntersecting) {
            entry.target.classList.add("bts-is-in-view");
            if (animateOnce) {
              observer.unobserve(entry.target);
            }
          } else if (!animateOnce) {
            entry.target.classList.remove("bts-is-in-view");
          }
        }
      },
      {
        threshold: threshold,
        rootMargin: rootMargin,
      }
    );

    for (var k = 0; k < items.length; k++) {
      observer.observe(items[k]);
    }
  }

  // Run on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-init on Shopify section load (Theme Editor)
  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector("[data-testimonials-stories]");
    if (section) {
      setupSection(section);
    }
  });
})();
